import { render, staticRenderFns } from "./ptAccountPercent.vue?vue&type=template&id=0f47ff82"
import script from "./ptAccountPercent.vue?vue&type=script&lang=js"
export * from "./ptAccountPercent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports